import { useMemo, useState } from "react";
import { API_BASE_URL } from "../config/api";

export default function RoutePreview({ from, to }) {
  const [status, setStatus] = useState("idle");

  const imageUrl = useMemo(() => {
    if (!from || !to || from === "-" || to === "-") return "";
    return `${API_BASE_URL}/api/routes/preview-image?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`;
  }, [from, to]);

  if (!imageUrl) {
    return <p className="muted">Select origin and destination to preview route.</p>;
  }

  if (status === "error") {
    return <p className="error">Unable to render route preview.</p>;
  }

  return (
    <div className="route-preview-card">
      {status === "loading" && <p className="muted">Loading route preview...</p>}
      <img
        src={imageUrl}
        alt={`Route from ${from} to ${to}`}
        className="route-map-image"
        onLoad={() => setStatus("ready")}
        onError={() => setStatus("error")}
      />
    </div>
  );
}
